// extracted by mini-css-extract-plugin
export default {"wrap":"SearchTTS_wrap__1b8+x","loading-wrapper":"SearchTTS_loading-wrapper__Wmwaj"};